import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg width="34" height="34" viewBox="14 11 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path
          d="M22.3779 14.6328L16.8779 20.6328L26.8779 20.6328M32.8779 20.6328L30.3779 20.6328"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip0)">
          <path
            d="M22.3779 14.6328L16.8779 20.6328L26.8779 20.6328M32.8779 20.6328L30.3779 20.6328"
            stroke="#F59C53"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M27.3779 30.6328L32.8779 24.6328L22.8779 24.6328M16.8779 24.6328L19.3779 24.6328"
          stroke="#F59C53"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip1)">
          <path
            d="M27.3779 30.6328L32.8779 24.6328L22.8779 24.6328M16.8779 24.6328L19.3779 24.6328"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="10"
          y="10"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.96 0 0 0 0 0.611 0 0 0 0 0.325 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <clipPath id="clip0">
          <rect width="6" height="7" fill="white" transform="translate(27.8779 14.6328)" />
        </clipPath>
        <clipPath id="clip1">
          <rect width="6" height="7" fill="white" transform="translate(15.8779 23.6328)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg width="34" height="34" viewBox="14 11 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path
          d="M22.3779 13.8779L16.8779 19.8779L26.8779 19.8779M32.8779 19.8779L30.3779 19.8779"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip0)">
          <path
            d="M22.3779 13.8779L16.8779 19.8779L26.8779 19.8779M32.8779 19.8779L30.3779 19.8779"
            stroke="#888888"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M27.3779 29.8779L32.8779 23.8779L22.8779 23.8779M16.8779 23.8779L19.3779 23.8779"
          stroke="#888888"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip1)">
          <path
            d="M27.3779 29.8779L32.8779 23.8779L22.8779 23.8779M16.8779 23.8779L19.3779 23.8779"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="14"
          y="12"
          width="22"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <clipPath id="clip0">
          <rect width="6" height="7" fill="white" transform="translate(27.8779 13.8779)" />
        </clipPath>
        <clipPath id="clip1">
          <rect width="6" height="7" fill="white" transform="translate(15.8779 22.8779)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
